import React from 'react'
import { useImpression } from '../../hooks/useImpression'

interface ImpressionTrackerProps {
  onImpress: () => void
  /** Optional dwell callback: fires with visible duration (ms) when the element leaves view. */
  onExit?: (dwellMs: number) => void
  children: React.ReactNode
}

/**
 * Wraps content and fires `onImpress` exactly once when it first scrolls ~50% into view.
 * Layout-neutral wrapper (full-width block) for analytics impression events.
 * When `onExit` is provided, also reports dwell time when the element leaves the viewport.
 */
const ImpressionTracker: React.FC<ImpressionTrackerProps> = ({
  onImpress,
  onExit,
  children,
}) => {
  const ref = useImpression<HTMLDivElement>(onImpress, onExit)
  return (
    <div ref={ref} style={{ width: '100%' }}>
      {children}
    </div>
  )
}

export default ImpressionTracker
